import { Box, LinearProgress, Modal, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';

import DynamicProgressBar from '../../components/progressBars/dynamicProgressBar';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AtplFooter from '../../components/ATPlab/atpFooter/AtplFooter';
import getHealthFunctions from '../Results/helperfunctions';
import ATPLogo from '../../images/AtpLab/atp_lab_logo.png'
import getAtplHealthFunctions from '../Results/ATPL/atplHelperFunctions';
import AtplProdReccomendationPopUp from './AtplProdReccomendationPopUp';
import { useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';

export const AtplResult = ({ allOverallScoreForAtplResultCard, symptomList, jumpToScoreCardSlideHandler }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isLaptop = useMediaQuery(theme.breakpoints.up('lg'));
    // const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
      const isSmallScreen = useMediaQuery('(max-width:499px)');
    const isGalaxyFold = useMediaQuery('(max-width:280px)');
    //store all score val
    const [allOverallScore, setAllOverallScore] = useState(allOverallScoreForAtplResultCard)
    //store config for overall Health score config
    const [overallHealthScoreConfig, setOverallHealthScoreConfig] = useState({
        overallHealthMainVal: "",
        scaledValue: "",
        statusColor: "",
        statusText: "",
        paramValue: "",

    })


    //store config & value of overall health card
    const [healthDetails, setHealthDetails] = useState([
        {
            title: "Health Scan",
            statusText: "",
            mainVal: symptomList.length > 0 ? symptomList[0]?.probability : null,
            symptomVal: symptomList.length > 0 ? symptomList[0]?.probability : null,
            symtomtext: symptomList.length > 0 ? symptomList[0]?.name : "",
            symtomColor: symptomList.length > 0 ? symptomList[0]?.symptomColour : "",
            statusColor: "#FEEC88",
            valSubText: symptomList.length > 0 ? "Probability" : "Out of 10",
            scaledValue: 0,
            paramValue: symptomList.length > 0 ? symptomList[0]?.probability : 80,
            keyTomatchWithResultCard: "allHealth"
        },
        {
            title: "Heart Health",
            statusText: "",
            mainVal: null,
            statusColor: "#FEEC88",
            valSubText: "Out of 5",
            scaledValue: 4,
            paramValue: 80,
            keyTomatchWithResultCard: "heartHealth"

        },
        {
            title: "Mental Health",
            statusText: "",
            mainVal: null,
            statusColor: "#FEEC88",
            valSubText: "Out of 5",
            scaledValue: 5,
            paramValue: 80,
            keyTomatchWithResultCard: "bodyFunction"
        },
        {
            title: "Physical Health",
            statusText: "",
            mainVal: null,
            statusColor: "#FEEC88",
            valSubText: "Out of 5",
            scaledValue: 4,
            paramValue: 80,
            keyTomatchWithResultCard: "physicalHealth"

        },
        {
            title: "Metabolic Health",
            statusText: "",
            mainVal: null,
            statusColor: "#FEEC88",
            valSubText: "Out of 5",
            scaledValue: 5,
            paramValue: 80,
            keyTomatchWithResultCard: "diabetesRisk"
        },
        {
            title: "Overall Disease Risk",
            statusText: "",
            mainVal: null,
            statusColor: "#FEEC88",
            valSubText: "Out of 5",
            scaledValue: 5,
            paramValue: 80,
            keyTomatchWithResultCard: "diseaseRisk"
        },

        // {
        //     title: "Liver Health",
        //     statusText: "",
        //     mainVal: null,
        //     statusColor: "#FEEC88",
        //     valSubText: "Out of 10",
        //     scaledValue: 4,
        //     paramValue: 80,
        //     detailScoreSlideIndex: null //null as liver card is not available 
        // },

    ]);
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    // Show the pop-up after 5 seconds
    useEffect(() => {
        // Check if the popup has already been shown in localStorage
        const hasShownPopup = localStorage.getItem('hasShownAtplProductRecoPopup');

        if (!hasShownPopup) {
            // Show the popup after 3 seconds if it hasn't been shown yet
            const timer = setTimeout(() => {
                setIsPopupVisible(true);
                localStorage.setItem('hasShownAtplProductRecoPopup', 'true'); // Mark as shown in localStorage
            }, 3000);

            // Cleanup timer if the component is unmounted before the popup is shown
            return () => clearTimeout(timer);
        }
    }, []);


    // Function to close the popup
    const closePopup = () => {
        setIsPopupVisible(false);
    };

    useEffect(() => {
        // Handle overall health score separately
        if (allOverallScoreForAtplResultCard.overallHealthScore) {
            const overallHealthConfig = updateHealthScore(allOverallScoreForAtplResultCard.overallHealthScore, 'overall health score');
            setOverallHealthScoreConfig(overallHealthConfig);
        }
        const healthCategories = [
            { category: "Metabolic Health", scoreKey: "overalldiabetesRiskScore", titleToFetchHealthFunction: "diabetes" },
            { category: "Mental Health", scoreKey: "overallMentalHealthScore", titleToFetchHealthFunction: "mental health" },
            { category: "Liver Health", scoreKey: "overallLiverHealthScore", titleToFetchHealthFunction: "liver health" },
            { category: "Physical Health", scoreKey: "overallPhysicalHealthScore", titleToFetchHealthFunction: "physical health" },
            { category: "Heart Health", scoreKey: "overallHeartHealthScore", titleToFetchHealthFunction: "heart health" },
            { category: "Overall Disease Risk", scoreKey: "overalldiseaseRiskScore", titleToFetchHealthFunction: "overall disease risk" }
        ];

        // Loop through each health category and update the health data if the score exists
        healthCategories.forEach(({ category, scoreKey, titleToFetchHealthFunction }, index) => {
            // if (index === 0 && symptomList.length > 0) {
            //     return; // Skips the first iteration
            // }
            if (allOverallScoreForAtplResultCard[scoreKey]) {
                updateHealthData(category, allOverallScoreForAtplResultCard[scoreKey], titleToFetchHealthFunction);
            }
        });

    }, [allOverallScore])


    const getScaledDiabetesScore = (value) => {
        // Ensure value is valid
        if (value === undefined || value === null) return 0;
      
        // Scale value from 0-100 to 0-5
        let scaledValue = (value / 100) * 5 
      
       // ensure that even small values return at least 1 ,else card will not genrate
        if (scaledValue < 1) {
         scaledValue = 1;  // Minimum value is 1 if scaling results in something smaller than 1
        }
        // Optionally, round to nearest integer for cleaner presentation
        return Math.round(scaledValue);  // This will return a value from 0 to 5
    };

    const getHeartHealthScoreOutOf5 = (value) => {
        // Ensure value is valid
        if (value === null || value === undefined) return 0;
        
        // Scale value based on thresholds, 0 - 6.6 corresponds to 1 - 5
        let scaledValue = 0;
        
        if (value >= 6.6) {
            scaledValue = 5; // Very High Risk
        } else if (value >= 3.3) {
            scaledValue = 4; // High Risk
        } else if (value >= 2.39) {
            scaledValue = 3; // Moderate Risk
        } else if (value >= 1.65) {
            scaledValue = 2; // Low Risk
        }  else {
            scaledValue = 1; // Very Low Risk
        }
    
        return scaledValue;  // Return the scaled value from 1 to 5
    };


    // Helper function to update only main overall health data text
    const updateHealthScore = (score, titleToFetchHealthFunction) => {
        const healthVal = Number(score);
        const integerHealthVal = Math.ceil(healthVal); // or Math.floor() if you want to round down
        const healthFunctions = getAtplHealthFunctions(titleToFetchHealthFunction);

        return {
            overallHealthMainVal: integerHealthVal,
            scaledValue: healthFunctions.getValue(integerHealthVal),
            statusColor: healthFunctions.getColor(integerHealthVal),
            statusText: healthFunctions.getStatus(integerHealthVal),
            paramValue: healthFunctions.getScaledValue(integerHealthVal)
        };
    };

    // Mapping titles to their corresponding score handling functions
    const healthFunctionMap = {
        "Metabolic Health": getScaledDiabetesScore,
        "Heart Health": getHeartHealthScoreOutOf5,
    };
    

    const updateHealthData = (title, HealthVal, titleToFetchHealthFunction) => {
        let mainHealthVal = Number(HealthVal);
        // Using Math.floor() to round down
        let integerallHealthVal = Math.ceil(mainHealthVal);
        let getHealthData = getAtplHealthFunctions(titleToFetchHealthFunction)

        // Common logic to get health data
        const healthData = {
            mainVal : healthFunctionMap[title] ? healthFunctionMap[title](HealthVal) : integerallHealthVal,
            scaledValue: getHealthData.getValue(integerallHealthVal),
            statusColor: getHealthData.getColor(integerallHealthVal),
            statusText: getHealthData.getStatus(integerallHealthVal),
            paramValue: getHealthData.getScaledValue(integerallHealthVal)
        };

        if (titleToFetchHealthFunction === "overall health score") {
            setOverallHealthScoreConfig({
                overallHealthMainVal: healthData.integerallHealthVal,
                scaledValue: healthData.scaledValue,
                statusColor: healthData.statusColor,
                statusText: healthData.statusText,
                paramValue: healthData.paramValue
            });
        }
        // Update the specified item by title with new values from healthFunctions
        // Update the specific health category details
        setHealthDetails(prevState => prevState.map(item =>
            item.title === title
                ? { ...item, ...healthData }  // Update health data for this item
                : item // Return unchanged item for other health categories
        ));
    };
    //handle Back arrow click logic 
    const onBackBtnClickHandler = () => {
        localStorage.setItem('flowComingFromAtpResultPage', 'true');
        navigate('/atpl-health-profile')
    }

    return (
        <Box sx={{ fontFamily: 'Poppins, sans-serif',}}> {
            isLaptop ?
                <Box className="atpl-intro-wrapper"
                    sx={{
                        // boxShadow: "0 10px 19px rgba(0, 0, 0, 0.07)",
                        backgroundColor: "white",
                        borderRadius: "15px",
                        minHeight: "250px",
                        position: "relative",
                        alignItems: "center",
                        marginTop: "50px",
                        paddingTop: "14px",
                        paddingX: "20px"

                    }}
                >
                    <Stack>
                        <Stack >
                            <Typography fontSize="13px" fontWeight="500" lineHeight="16px" color="#000000BD" textAlign="center" padding="4px 45px">
                                Click each score to learn how the score was composed and find products that can help.
                            </Typography>
                        </Stack>
                        <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center" >
                            {
                                healthDetails && healthDetails?.map((data, index) => (
                                    (data.mainVal !== undefined && data.mainVal !== null) &&
                                    <Box
                                        key={index}
                                        onClick={() => jumpToScoreCardSlideHandler(data.keyTomatchWithResultCard)}
                                        sx={{
                                            width: '40%',
                                            margin: "10px 5px",
                                            height: '156px',
                                            bgcolor: 'linear-gradient(180deg, #FCFAFA 0%, #E4E3E3 100%)',
                                            borderRadius: "15px",
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            padding: "0px 10px",
                                            textAlign: "center",
                                            // background: `linear-gradient(180deg, #FCFAFA 0%, #E4E3E3 100%)`
                                            borderRadius: "15px",
                                            background: "linear-gradient(180deg, #FCFAFA 0%, #E4E3E3 100%)",
                                            // boxShadow: "0px 230px 64px 0px rgba(0, 0, 0, 0.00), 0px 147px 59px 0px rgba(0, 0, 0, 0.01), 0px 83px 50px 0px rgba(0, 0, 0, 0.05), 0px 37px 37px 0px rgba(0, 0, 0, 0.09), 0px 9px 20px 0px rgba(0, 0, 0, 0.10)",
                                            boxShadow: '0px 230px 64px 0px rgba(0, 0, 0, 0.00), 0px 147px 59px 0px rgba(0, 0, 0, 0.01), 0px 83px 50px 0px rgba(0, 0, 0, 0.05), 0px 37px 25px 0px rgba(0, 0, 0, 0.07), 0px 9px 15px 0px rgba(0, 0, 0, 0.10)'

                                        }}
                                    >
                                        <Typography fontSize="13px" fontWeight="600" lineHeight="17px">{data.title}</Typography>
                                        <Typography style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            width: '100%',
                                            display: 'block',
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            lineHeight: "17px",
                                            textAlign: "center",
                                            color: data.symtomColor ? data.symtomColor : data.statusColor ? data.statusColor : "black"
                                        }}>
                                            {data.symtomtext ? data?.symtomtext : data?.statusText}
                                        </Typography>

                                        <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center" padding="5px 0px">
                                            <DynamicProgressBar
                                                paramValue={data.paramValue}
                                                paramSize={85}
                                                paramThickness={8}
                                                barColor={data.symtomColor ? data.symtomColor : data.statusColor}
                                                storkeColor={data.symtomColor ? data.symtomColor : data.statusColor}

                                            />
                                            <Stack display="flex" flexDirection="column" >


                                                <Typography
                                                    variant="h4"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        textAlign: "center",
                                                        fontSize: "25px",
                                                        fontWeight: "600"


                                                    }}
                                                    sx={{ fontWeight: 'bold' }}
                                                >

                                                    {data.symptomVal ? `${data.symptomVal}% ` : Number(Math.round(data.mainVal))}
                                                    <Typography style={{
                                                        fontSize: "10px",
                                                        fontWeight: "600",
                                                        lineHeight: "15px",
                                                        textAlign: "center"
                                                    }}>{data.valSubText}</Typography>


                                                </Typography>



                                            </Stack>
                                        </Box>

                                    </Box>
                                ))
                            }

                        </Box>
                        <Stack
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "10px",

                            }}>

                            <Stack
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "6px 0px",
                                }}>
                                <img style={{ width: "136px", height: "auto", }} src={ATPLogo} alt="ATPL logo"></img>
                            </Stack>
                        </Stack>
                    </Stack>
                    {isPopupVisible &&
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%"

                        }}>

                            <Modal
                                open={isPopupVisible}
                                // onClose={handleClose}
                                sx={{
                                    '& .MuiBackdrop-root': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.2)', // Adjust backdrop opacity (0.5 means 50% opacity)
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        bgcolor: '#FCFCFC',
                                        borderRadius: '20px',
                                        boxShadow: '0px 4px 4px 0px #00000040',
                                        padding: "0px 14px",
                                        maxWidth: '400px',
                                        outline: 'none',
                                    }}
                                >
                                    <AtplProdReccomendationPopUp closePopup={closePopup} />
                                </Box>
                            </Modal>
                        </Box>

                    }
                </Box>
                :
                <Box className="atpl-intro-wrapper" minHeight="100vh" position="relative" alignItems="center" width="90%" >
                    <Stack >
                        <Stack width="100%" textAlign="start" >

                            <ArrowBackIosNewIcon sx={{ fontSize: 19, cursor: "pointer" }} onClick={onBackBtnClickHandler} />

                        </Stack>
                            <Stack width="100%" display="flex" alignItems='center' flexDirection="row" justifyContent='space-between' padding='2px 0px'>

                                <Stack marginBottom={isSmallScreen && "14px"}>
                                    <Typography
                                        color="black"
                                        variant="h6" component="h6" fontWeight="bold"
                                        sx={{
                                            fontSize: isGalaxyFold ? '18px' : isSmallScreen ? '20px' : '23px',
                                        }}
                                      
                                    >
                                        Overall Health Score
                                    </Typography>
                                    <Typography
                                        // color="#F2BF3A"
                                        color={overallHealthScoreConfig.statusColor}
                                        variant="p" component="p" fontWeight="600"
                                        sx={{
                                            fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '14px' : '15px',
                                        }}
                                    >
                                        {/* Very good */}
                                        {overallHealthScoreConfig.statusText}
                                    </Typography>
                                </Stack>
                                <Box position="relative" display="inline-flex" >
                                    <DynamicProgressBar
                                        paramValue={overallHealthScoreConfig.paramValue}
                                        barColor={overallHealthScoreConfig.statusColor}
                                        storkeColor={overallHealthScoreConfig?.statusColor && overallHealthScoreConfig.statusColor}
                                        paramSize={isGalaxyFold ? 60 : isSmallScreen ? 50 : 70}
                                        paramThickness={isGalaxyFold ? 6 : isSmallScreen ? 5 : 8}
                                        
                                    />
                                    <Stack display="flex" flexDirection="column">
                                        <Typography
                                            variant="h6"

                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                textAlign: "center",
                                                // fontSize: "30px",
                                                // fontSize: isGalaxyFold ? '20px' : isSmallScreen ? '20px' : '30px',
                                                fontWeight: "600",
                                                lineHeight: "15px",
                                                textAlign: "center",

                                            }}

                                        >
                                            {overallHealthScoreConfig.overallHealthMainVal}
                                            {/* <Typography style={{
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    lineHeight: "15px",
                                    textAlign: "center",
                                    marginTop: "10px"
                                }}>
                                    Out of 10
                                </Typography> */}

                                        </Typography>

                                    </Stack>
                                </Box>
                            </Stack>                      

                        <Stack >
                            <Typography fontSize={isSmallScreen ? "12px" : "14px"} fontWeight="600" textAlign="center" lineHeight="16px" padding={ !isSmallScreen ? "46px 0px 6px 0px" : "27px 0px 10px 0px" } color="#000000BD">
                                Click each score to learn how the score was composed and find products that can help.
                            </Typography>
                        </Stack>

                        <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center">
                            {
                                healthDetails && healthDetails?.map((data, index) => (
                                    (data.mainVal !== undefined && data.mainVal !== null) &&
                                    <Box
                                        key={index}
                                        onClick={() => jumpToScoreCardSlideHandler(data.keyTomatchWithResultCard)}
                                        sx={{
                                            width:  isGalaxyFold  || isSmallScreen ? '38%' : '40%',
                                            margin: "10px 5px",
                                            height: isSmallScreen ? '110px' : '140px',

                                            borderRadius: "15px",
                                            boxShadow: '0px 147px 59px 0px rgba(0, 0, 0, 0.06)',
                                            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',
                                            // '0 28px 19px rgba(0, 0, 0, 0.03)',
                                            // boxShadow: [
                                            //     '0px 9px 20px 0px rgba(0, 0, 0, 0.1)',
                                            //     '0px 37px 37px 0px rgba(0, 0, 0, 0.09)',
                                            //     '0px 83px 50px 0px rgba(0, 0, 0, 0.05)',
                                            //     '0px 147px 59px 0px rgba(0, 0, 0, 0.01)',
                                            //     '0px 230px 64px 0px rgba(0, 0, 0, 0)',
                                            // ].join(', '),
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            padding: "0px 10px",
                                            textAlign: "center",
                                            cursor: "pointer",

                                            background: `linear-gradient(180deg, #FCFAFA 0%, #E4E3E3 100%)`


                                        }}
                                    >
                                        <Typography fontSize="13px" fontWeight="600" lineHeight="17px"

                                        >{data.title}</Typography>
                                        <Typography

                                            sx={{
                                                overflow: 'hidden',           // Ensure overflowing text is hidden
                                                textOverflow: 'ellipsis',     // Add ellipsis when text overflows
                                                whiteSpace: 'nowrap',         // Prevent wrapping of text
                                                width: '100%',                // Ensure it takes the full width of the container
                                                display: 'block',             // Makes sure the ellipsis behavior works
                                                fontSize: isSmallScreen ? "10px" : "12px",
                                                fontWeight: "600",
                                                lineHeight: "17px",
                                                textAlign: "center",
                                                color: data.symtomColor ? data.symtomColor : data.statusColor ? data.statusColor : "black"

                                            }}>
                                            {data.symtomtext ? data?.symtomtext : data?.statusText}

                                        </Typography>

                                        <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center" padding="5px 0px">
                                            <DynamicProgressBar
                                                paramValue={data.paramValue}
                                                paramSize={isSmallScreen ? 60 : 70}
                                                paramThickness={5}
                                                storkeColor={data.symtomColor ? data.symtomColor : data.statusColor}

                                                barColor={data.symtomColor ? data.symtomColor : data.statusColor}

                                            />
                                            <Stack display="flex" flexDirection="column" >


                                                <Typography
                                                    variant="h4"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        textAlign: "center",
                                                        fontSize: isSmallScreen ? "18px" : "20px",
                                                        fontWeight: "600"


                                                    }}
                                                    sx={{ fontWeight: 'bold' }}
                                                >

                                                    {data.symptomVal ? `${data.symptomVal}% ` : Number(Math.round(data.mainVal))}

                                                    <Typography style={{
                                                        fontSize: isSmallScreen ? "6px" : "8px",
                                                        fontWeight: "600",
                                                        lineHeight: "15px",
                                                        textAlign: "center"
                                                    }}>{data.valSubText}</Typography>


                                                </Typography>



                                            </Stack>
                                        </Box>

                                    </Box>
                                ))
                            }

                        </Box>
                        <Stack
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "20px 10px 10px 10px",
                                // position: "absolute",
                                // bottom: "0",
                                // left: "0",
                                // right: "0",
                                // transform: "translateX(-50%.-50%)"  // Center horizontally
                            }}>
                            <Stack paddingTop="8px">
                                <Typography fontSize="10px" fontWeight="400" lineHeight="15px">
                                    These numbers are only estimates and are not a substitute for the judgment of a healthcare professional. They are intended to improve awareness and general wellness.
                                </Typography>
                            </Stack>

                            <Stack
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "6px 0px",
                                }}>
                                <img style={{ width: "136px", height: "auto", }} src={ATPLogo} alt="ATPL logo"></img>
                            </Stack>
                        </Stack>
                    </Stack>
                    {isPopupVisible &&
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%"

                        }}>

                            <Modal
                                open={isPopupVisible}
                                // onClose={handleClose}
                                sx={{
                                    '& .MuiBackdrop-root': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.2)', // Adjust backdrop opacity (0.5 means 50% opacity)
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        bgcolor: '#FCFCFC',
                                        borderRadius: '20px',
                                        boxShadow: '0px 4px 4px 0px #00000040',
                                        padding: "0px 14px",

                                        minWidth: {
                                            xs: '80%',
                                            sm: '350px',
                                            md: '400px',
                                            lg: '400px'
                                        },

                                        outline: 'none',
                                    }}
                                >
                                    <AtplProdReccomendationPopUp closePopup={closePopup} />
                                </Box>
                            </Modal>
                        </Box>

                    }
                </Box>
        }

        </Box >
    )
}

export default AtplResult


